<template>
  <teleport to="body">
    <div :style="{ top: showY + 'px', left: showX + 'px' }" class="menu-container" v-show="show">
      <MenuItem />
    </div>
  </teleport>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import MenuItem from './MenuItem.vue';
import { contextMenuStore } from '@/components/ContextMenu/store/contextMenuStore';
const store = contextMenuStore();
const { show, showX, showY } = storeToRefs(store);
</script>

<style lang="less">
.menu-container {
  position: fixed;
  z-index: 10000;
}
</style>
